import React, { Component, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./modalInfoApp.module.scss";
import { withAuth } from "../../../shared/containers/containerAuth";
import PhoneLink from "../../../shared/items/static/phoneLink";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

class ModalInfoApp extends Component {
  render() {
    const { onCloseHandler, isOpen } = this.props;

    if (!isOpen) return null;

    const node = document.getElementById("modalContainerId");
    if (!node) return null;

    return ReactDOM.createPortal(
      <div className={styles.infoAppContainer}>
        <div className={styles.infoAppCloseContainer} onClick={onCloseHandler}>
          <HighlightOffIcon style={{ color: "red", cursor: "pointer" }} />
        </div>
        <div>
          <p className={styles.copy}>Система мониторинга транспортных средств ТрансНавигатор</p>
          <p className={styles.copy}>Версия ПО: 2.15.6</p>
          <p className={styles.copy}>Номер версии метрологической части ПО измерения длинны маршрута: 2.6</p>
          <p className={styles.copy}>Контрольная сумма метрологической части ПО измерения длинны маршрута: e0af</p>

          <p className={styles.copy}>Номер версии метрологической части ПО измерения временных интервалов: 2.2</p>
          <p className={styles.copy}>Контрольная сумма метрологической части ПО измерения временных интервалов: eea0</p>

          <p className={styles.support}>
            Техническая поддержка:
            <PhoneLink title="+375 (17) 282-00-92" link="+375172820092" />,
            <PhoneLink title="+375 (17) 277-24-04" link="+375172772404" />,
            <PhoneLink title="+375 (29) 190-64-55" link="+375291906455" />
          </p>
        </div>
      </div>,
      node
    );
  }
}

export default withAuth(React.memo(ModalInfoApp));
